import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageUtil } from '../utils/local-storage.util';
import { OauthResult } from '../interfaces/oauth.interface';

@Injectable({
  providedIn: 'root'
})
export class SelectedDnService {
  private readonly STORAGE_KEY = 'selectedVWDn';
  private selectedDnSubject: BehaviorSubject<string>;
  public selectedDn$: Observable<string>;

  constructor() {
    // Inicializa com o valor do localStorage ou string vazia
    const initialValue = this.getInitialValue();
    this.selectedDnSubject = new BehaviorSubject<string>(initialValue);
    this.selectedDn$ = this.selectedDnSubject.asObservable();
  }

  /**
   * Obtém o valor inicial do DN do localStorage
   */
  private getInitialValue(): string {
    try {
      return String(LocalStorageUtil.getSelectedVWDn());
    } catch {
      // Se não existir, tenta pegar o primeiro DN do usuário
      try {
        const user: OauthResult = LocalStorageUtil.getVWUser();
        if (user.montadoras && user.montadoras.length > 0) {
          const firstManufacturer = user.montadoras[0];
          if (firstManufacturer.concessionarias && firstManufacturer.concessionarias.length > 0) {
            const firstDn = String(firstManufacturer.concessionarias[0].codigo);
            LocalStorageUtil.setSelectedVWDn(firstDn);
            return firstDn;
          }
        }
      } catch {
        // Se não conseguir, retorna string vazia
      }
      return '';
    }
  }

  /**
   * Obtém o valor atual do DN selecionado
   */
  getSelectedDn(): string {
    return this.selectedDnSubject.value;
  }

  /**
   * Define o DN selecionado e notifica todos os subscribers
   */
  setSelectedDn(dn: string | number): void {
    const dnString = String(dn);
    if (dnString !== this.selectedDnSubject.value) {
      // Salva no localStorage
      LocalStorageUtil.setSelectedVWDn(dnString);
      // Atualiza o BehaviorSubject (notifica todos os subscribers)
      this.selectedDnSubject.next(dnString);
    }
  }

  /**
   * Obtém o DN como número
   */
  getSelectedDnAsNumber(): number {
    const dn = this.getSelectedDn();
    return parseInt(dn, 10) || 0;
  }
}
